import { ButtonDropdownProps } from '@amzn/awsui-components-react';

import { constants } from '../../../common/Localization';

/**
 * Defines the stages of app prioritization
 */
export enum STAGE_VALUES {
    DEFAULT = 'default',
    EDIT = 'edit',
    START_OVER = 'startover'
}

export const PRIORITIZATION_ACTIONS: ButtonDropdownProps.Items = [
    {id: STAGE_VALUES.START_OVER, text: constants.START_FROM_THE_BEGINNING},
    {id: STAGE_VALUES.EDIT, text: constants.APP_PRIORITIZATION_EDIT_BUTTON_TEXT}
];

export const VISIBLE_COLUMNS = ['description', 'name', 'applicationId', 'ranking'];

export const MAX_NUMERIC_PARTITION_BOUNDS = 10;
export const MIN_NUMERIC_PARTITION_BOUNDS = 2;

export const MAX_NUMBER_OF_DISTINCT_VALUES = 50; 
